import { render, staticRenderFns } from "./simpleReferralChain.vue?vue&type=template&id=78e60e4f&scoped=true"
import script from "./simpleReferralChain.vue?vue&type=script&lang=js"
export * from "./simpleReferralChain.vue?vue&type=script&lang=js"
import style0 from "./simpleReferralChain.vue?vue&type=style&index=0&id=78e60e4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e60e4f",
  null
  
)

export default component.exports